(function () {
    'use strict';

    angular.module('swif.openbase')
        .factory('swifOpenbaseSiteService', swifOpenbaseSiteService);

    /**
     * @ngdoc service
     * @name swif.openbase.swifOpenbaseSiteService
     * @description site manager
     * @requires swif.framework.swifFrameworkService
     **/
    function swifOpenbaseSiteService(swif, swifOpenbaseCustomFieldsService) {
        'ngInject';
        var service = {};
        service.resolveData = function (options) {
            function checkRouteOptions() {
                if (swif.module.modules.opengst_carto) {
                    //add leaflet
                    if (!options) {
                        options = {resources: ['leaflet']};
                    } else if (options && !options.resources) {
                        options.resources = ['leaflet'];
                    } else if (options && options.resources) {
                        options.resources.push('leaflet');
                    }
                }
                return swif.route.check(options);
            }
            function createCollection () {
                var data = {};
                return service.createCollection().then(function (collection) {
                    data.sites = collection;
                    return data;
                });
            }
            return swif.settings.initialize()
                .then(checkRouteOptions)
                .then(createCollection);
        };
        service.createCollection = function () {
            var filter = {};
            swif.data.sortOnRaw(filter, 'parents_count ASC, name ASC');
            return swif.collections.createOrUpdate('sites', 'site', filter);
        };
        service.getCollection = function () {
            return swif.collections.getCollection('sites');
        };
        service.callback = function (error, data) {
            service.getCollection().defaultActionCallback(error, data);
        };
        service.preModal = function (data) {
            service.getCollection().preModal(data);
            if (data.action.id === 'edit') {
                var params = {fields: []};
                if (swif.module.modules.openresa) {
                    params.fields = _.union(params.fields, [
                        'color',
                        'accommodation_capacity',
                        'optional_product_ids',
                        'option_of_product_ids',
                        'resa_service_manager_ids',
                        'resa_user_manager_ids',
                        'internal_booking',
                        'internal_bookable_notice',
                        'external_booking',
                        'external_bookable_notice',
                        'service_bookable_ids',
                        'partner_type_bookable_ids',
                        'block_booking'
                    ]);
                }
                if (!_.isEmpty(params.fields)) {
                    swif.data.get('site', data.model.id, params)
                    .then(function (model) {
                        swif.data.updateObj(model, data.model);
                    });
                }
            }
        };
        service.preValidate = function (data) {
            if (data.action.id === 'copy') {
                // _inherits field, must not be copied
                delete data.model.product_id;
            }
            swifOpenbaseCustomFieldsService.sanitize(data);

            return service.getCollection().preValidate(data);
        };
        /**
         * Defines fields required to get site address
         * @return {Array} Site address fields
         */
        service.getSiteAddressFields = function() {
            return ['street', 'street2', 'zip', 'city', 'owners', 'parcel_matricule', 'cadastral_parcel'];
        };
        /**
         * Return promise with site adress if patrimoine module is installed
         * @param {Number} siteId - Id of the site
         * @return {Object} Site object with adress
         */
        service.getSiteAddressById = function(siteId) {
            if (swif.settings.app.modules.openstc_patrimoine && siteId) {
                var filter = {fields: service.getSiteAddressFields()};
                return swif.data.get('site', siteId, filter);
            }
        };
        return service;
    }


})();
